import { FC, useMemo } from 'react';

import { cn } from '../utils/class-names.util.ts';

interface Props {
  className?: string;
}

export const CommonGlossyEffect: FC<Props> = ({ className }) => {
  const classNames = useMemo(
    () =>
      cn(
        'blur-xs bg-glossy-effect translate-x-(--glossy-effect-offset) translate-y-(--glossy-effect-offset) absolute inset-0',
        className ?? 'rounded-full'
      ),
    [className]
  );

  const containerClassNames = useMemo(
    () => cn('absolute inset-0 overflow-hidden', className ?? 'rounded-full'),
    [className]
  );

  return (
    <div className={containerClassNames}>
      <div className={classNames} />
    </div>
  );
};
